export type TransactionMode = "SingleNode" | "ClusterWide";
